(() => {
  const root = document.querySelector('[data-commerce-drawers]');
  if (!root) return;

  const drawers = [...root.querySelectorAll('[data-commerce-drawer]')];
  const cartBody = root.querySelector('[data-cart-drawer-body]');
  const cartFooter = root.querySelector('[data-cart-drawer-footer]');
  const wishlistBody = root.querySelector('[data-wishlist-drawer-body]');
  const wishlistFooter = root.querySelector('[data-wishlist-drawer-footer]');
  const wishlistPage = document.querySelector('[data-wishlist-page]');
  const wishlistPageGrid = wishlistPage?.querySelector('[data-wishlist-page-grid]');
  const wishlistPageEmpty = wishlistPage?.querySelector('[data-wishlist-page-empty]');
  const wishlistPageToolbar = wishlistPage?.querySelector('[data-wishlist-page-toolbar]');
  const quickViewBody = root.querySelector('[data-quick-view-body]');
  const status = root.querySelector('[data-commerce-status]');
  const wishlistKey = 'buskins-wishlist';
  const demoCartKey = 'buskins-demo-cart';
  let activeDrawer = null;
  let lastTrigger = null;
  let cartRequest = null;
  let quickViewState = null;

  const escapeHtml = (value = '') =>
    String(value).replace(
      /[&<>"']/g,
      (character) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        })[character]
    );

  const announce = (message) => {
    if (!status) return;
    status.textContent = '';
    window.setTimeout(() => {
      status.textContent = message;
    }, 30);
  };

  const getWishlist = () => {
    try {
      const items = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      if (!Array.isArray(items)) return [];
      return items.map((item) => {
        if (item.id !== '/collections/all?view=product-preview' || !item.title) return item;
        return {
          ...item,
          id: `demo:${item.title
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '')}`
        };
      });
    } catch (error) {
      return [];
    }
  };

  const saveWishlist = (items) => {
    try {
      localStorage.setItem(wishlistKey, JSON.stringify(items));
    } catch (error) {}
  };

  const getDemoCart = () => {
    try {
      const item = JSON.parse(sessionStorage.getItem(demoCartKey) || 'null');
      return item && item.quantity > 0 ? item : null;
    } catch (error) {
      return null;
    }
  };

  const saveDemoCart = (item) => {
    try {
      if (item && item.quantity > 0) {
        sessionStorage.setItem(demoCartKey, JSON.stringify(item));
      } else {
        sessionStorage.removeItem(demoCartKey);
      }
    } catch (error) {}
  };

  const money = (amount, currency = root.dataset.currency || 'EGP') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      }).format(Number(amount || 0) / 100);
    } catch (error) {
      return `${currency} ${(Number(amount || 0) / 100).toFixed(2)}`;
    }
  };

  const priceTextToCents = (value) => {
    const normalized = String(value || '').replace(/[^\d.]/g, '');
    return Math.round(Number(normalized || 0) * 100);
  };

  const normalizeImageUrl = (value = '') => {
    if (value.startsWith('//')) return `https:${value}`;
    return value;
  };

  const stripHtml = (value = '') =>
    String(value)
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const swatchForValue = (value = '') => {
    const key = value.toLowerCase().trim();
    const palette = {
      'powder blue': '#B7C9DA',
      'dusty blue': '#8FAFC7',
      'floral blue': '#6F93B7',
      blue: '#6F93B7',
      navy: '#172C45',
      midnight: '#172C45',
      ivory: '#FAF7F2',
      cream: '#FAF7F2',
      beige: '#EFE3D6',
      sand: '#EFE3D6',
      blush: '#E9CEC3',
      orange: '#C97643',
      sunset: '#C97643',
      charcoal: '#1E1E1E',
      black: '#1E1E1E',
      white: '#FFFFFF'
    };
    return palette[key] || '#B7C9DA';
  };

  const updateHeaderCounts = (cartCount) => {
    document.querySelectorAll('[data-cart-count]').forEach((counter) => {
      counter.textContent = cartCount;
      counter.hidden = cartCount < 1;
      counter.closest('[data-drawer-open="cart"]')?.setAttribute('aria-label', `Cart, ${cartCount} items`);
    });

    const wishlistCount = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((counter) => {
      counter.textContent = wishlistCount;
      counter.hidden = wishlistCount < 1;
    });

    document.querySelectorAll('[data-wishlist-item]').forEach((button) => {
      const selected = getWishlist().some((item) => item.id === button.dataset.wishlistId);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute(
        'aria-label',
        `${selected ? 'Remove' : 'Save'} ${button.dataset.wishlistTitle || 'product'} ${selected ? 'from' : 'to'} wishlist`
      );
    });
  };

  const getFocusable = (drawer) =>
    [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter(
      (element) => !element.hidden && element.getClientRects().length
    );

  const closeDrawer = () => {
    if (!activeDrawer) return;
    activeDrawer.classList.remove('is-active');
    activeDrawer.setAttribute('aria-hidden', 'true');
    root.classList.remove('is-open');
    document.documentElement.classList.remove('buskins-drawer-open');
    const trigger = lastTrigger;
    activeDrawer = null;
    window.setTimeout(() => trigger?.focus(), 30);
  };

  const openDrawer = async (name, trigger = document.activeElement) => {
    const drawer = root.querySelector(`[data-commerce-drawer="${name}"]`);
    if (!drawer) return;

    if (activeDrawer && activeDrawer !== drawer) {
      activeDrawer.classList.remove('is-active');
      activeDrawer.setAttribute('aria-hidden', 'true');
    }

    lastTrigger = trigger;
    activeDrawer = drawer;
    root.classList.add('is-open');
    document.documentElement.classList.add('buskins-drawer-open');
    drawer.classList.add('is-active');
    drawer.setAttribute('aria-hidden', 'false');

    if (name === 'cart') await refreshCart();
    if (name === 'wishlist') renderWishlist();

    window.requestAnimationFrame(() => drawer.querySelector('[data-drawer-close]')?.focus());
  };

  const renderEmpty = (target, templateName, showRecommendations = false) => {
    const template = root.querySelector(`[data-${templateName}-empty-template]`);
    target.replaceChildren(template?.content.cloneNode(true) || document.createTextNode(''));
    const recommendations = root.querySelector('[data-drawer-recommendations]');
    if (showRecommendations && recommendations) {
      const clone = recommendations.cloneNode(true);
      clone.hidden = false;
      target.append(clone);
    }
  };

  const renderProgress = (totalPrice) => {
    const threshold = Number(root.dataset.freeShippingThreshold || 0);
    const wrapper = root.querySelector('[data-cart-progress]');
    if (!wrapper || threshold <= 0) return;

    const remaining = Math.max(threshold - totalPrice, 0);
    const percentage = Math.min((totalPrice / threshold) * 100, 100);
    wrapper.hidden = false;
    wrapper.style.setProperty('--cart-progress', `${percentage}%`);
    root.querySelector('[data-cart-progress-bar]').style.width = `${percentage}%`;
    root.querySelector('[data-cart-progress-value]').textContent = `${Math.round(percentage)}%`;
    root.querySelector('[data-cart-progress-message]').textContent =
      remaining > 0 ? `Add ${money(remaining)} for complimentary delivery` : 'Complimentary delivery unlocked — lovely choice.';
  };

  const removeIcon = `
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none">
      <path d="M5 7h14M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`;

  const cartItemMarkup = (item, demo = false) => {
    const optionText = demo
      ? item.optionsText || 'Selected colour / Selected size'
      : (item.options_with_values || [])
          .filter((option) => option.value && option.value !== 'Default Title')
          .map((option) => `${escapeHtml(option.name)}: ${escapeHtml(option.value)}`)
          .join('<br>');
    const image = item.image || '';
    const url = item.url || root.dataset.shopUrl;
    const linePrice = demo ? item.price * item.quantity : item.final_line_price;
    const originalLinePrice = demo ? 0 : item.original_line_price;
    const badge = originalLinePrice > linePrice ? '<span class="buskins-drawer-item__badge">On sale</span>' : '';

    return `
      <article class="buskins-drawer-item" data-cart-line="${demo ? 'demo' : item.key}">
        <a class="buskins-drawer-item__media" href="${escapeHtml(url)}">
          ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title || item.title)}" width="224" height="284" loading="lazy">` : ''}
          ${badge}
        </a>
        <div class="buskins-drawer-item__content">
          <div class="buskins-drawer-item__top">
            <a class="buskins-drawer-item__title" href="${escapeHtml(url)}">${escapeHtml(item.product_title || item.title)}</a>
            <button class="buskins-drawer-item__remove" type="button" data-cart-remove aria-label="Remove ${escapeHtml(item.product_title || item.title)}">
              ${removeIcon}
            </button>
          </div>
          ${optionText ? `<p class="buskins-drawer-item__options">${optionText}</p>` : ''}
          <p class="buskins-drawer-item__price">
            ${money(demo ? item.price : item.final_price)}
            ${originalLinePrice > linePrice ? `<s>${money(item.original_price)}</s>` : ''}
          </p>
          <div class="buskins-drawer-item__bottom">
            <div class="buskins-drawer-item__quantity" aria-label="Quantity for ${escapeHtml(item.product_title || item.title)}">
              <button type="button" data-cart-quantity-minus aria-label="Decrease quantity">−</button>
              <span aria-live="polite">${item.quantity}</span>
              <button type="button" data-cart-quantity-plus aria-label="Increase quantity">+</button>
            </div>
            <strong class="buskins-drawer-item__line-price">${money(linePrice)}</strong>
          </div>
        </div>
      </article>`;
  };

  const renderCart = (cart) => {
    const demoItem = getDemoCart();
    const shopifyItems = cart.items || [];
    const useDemo = Boolean(demoItem && shopifyItems.length === 0);
    const items = useDemo ? [demoItem] : shopifyItems;
    const totalPrice = useDemo ? demoItem.price * demoItem.quantity : cart.total_price || 0;
    const count = useDemo ? demoItem.quantity : cart.item_count || 0;

    updateHeaderCounts(count);
    renderProgress(totalPrice);

    if (!items.length) {
      renderEmpty(cartBody, 'cart', true);
      cartFooter.hidden = true;
      return;
    }

    cartBody.innerHTML = `<div class="buskins-drawer__items">${items.map((item) => cartItemMarkup(item, useDemo)).join('')}</div>`;
    const recommendations = root.querySelector('[data-drawer-recommendations]');
    if (recommendations) {
      const clone = recommendations.cloneNode(true);
      clone.hidden = false;
      cartBody.append(clone);
    }
    root.querySelector('[data-cart-subtotal]').textContent = money(totalPrice);
    cartFooter.hidden = false;
  };

  const fetchCart = async () => {
    if (cartRequest) return cartRequest;
    cartRequest = fetch(`${root.dataset.cartUrl}.js`, {
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .finally(() => {
        cartRequest = null;
      });
    return cartRequest;
  };

  const refreshCart = async () => {
    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch (error) {
      cartBody.innerHTML = '<div class="buskins-drawer__empty"><h3>We could not refresh your bag.</h3><p>Please try again in a moment.</p></div>';
      announce(error.message);
    }
  };

  const changeCartItem = async (key, quantity) => {
    if (key === 'demo') {
      const item = getDemoCart();
      if (!item) return;
      item.quantity = Math.max(0, quantity);
      saveDemoCart(item);
      renderCart({ items: [], item_count: 0, total_price: 0 });
      announce(quantity > 0 ? 'Quantity updated' : 'Item removed from your bag');
      return;
    }

    cartBody.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${root.dataset.cartChangeUrl}.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Unable to update your bag');
      renderCart(cart);
      announce(quantity > 0 ? 'Quantity updated' : 'Item removed from your bag');
    } catch (error) {
      announce(error.message);
    } finally {
      cartBody.removeAttribute('aria-busy');
    }
  };

  const wishlistItemMarkup = (item) => `
    <article class="buskins-drawer-item" data-wishlist-line="${escapeHtml(item.id)}">
      <a class="buskins-drawer-item__media" href="${escapeHtml(item.url)}">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="224" height="284" loading="lazy">` : ''}
        <span class="buskins-drawer-item__badge">Saved</span>
      </a>
      <div class="buskins-drawer-item__content">
        <div class="buskins-drawer-item__top">
          <a class="buskins-drawer-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
          <button class="buskins-drawer-item__remove" type="button" data-wishlist-remove="${escapeHtml(item.id)}" aria-label="Remove ${escapeHtml(item.title)} from wishlist">
            ${removeIcon}
          </button>
        </div>
        <p class="buskins-drawer-item__options">Saved for later</p>
        <p class="buskins-drawer-item__price">${escapeHtml(item.price || '')}</p>
        <div class="buskins-drawer-item__bottom">
          ${
            item.variantId && item.available !== 'false'
              ? `<button class="buskins-drawer-item__wishlist-action" type="button" data-wishlist-add="${escapeHtml(item.variantId)}" data-wishlist-id="${escapeHtml(item.id)}">
                  <span>Add to bag</span><span aria-hidden="true">+</span>
                </button>`
              : `<a class="buskins-drawer-item__wishlist-action" href="${escapeHtml(item.url)}"><span>Choose options</span><span aria-hidden="true">→</span></a>`
          }
        </div>
      </div>
    </article>`;

  const wishlistPageLabel = (name, fallback) => wishlistPage?.dataset[name] || fallback;

  const wishlistPageItemMarkup = (item) => {
    const canAdd = item.variantId && item.available !== 'false';
    const primaryAction = canAdd
      ? `<button class="buskins-wishlist-card__primary" type="button" data-wishlist-add="${escapeHtml(item.variantId)}" data-wishlist-id="${escapeHtml(item.id)}">
          <span>${escapeHtml(wishlistPageLabel('labelAdd', 'Add to bag'))}</span><span aria-hidden="true">+</span>
        </button>`
      : `<a class="buskins-wishlist-card__primary" href="${escapeHtml(item.url)}">
          <span>${escapeHtml(wishlistPageLabel('labelOptions', 'Choose options'))}</span><span aria-hidden="true">→</span>
        </a>`;

    return `
      <article class="buskins-wishlist-card" data-wishlist-line="${escapeHtml(item.id)}">
        <a class="buskins-wishlist-card__media" href="${escapeHtml(item.url)}">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="640" height="800" loading="lazy">` : ''}
          <span>${escapeHtml(wishlistPageLabel('labelSaved', 'Saved'))}</span>
        </a>
        <div class="buskins-wishlist-card__copy">
          <div class="buskins-wishlist-card__heading">
            <a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
            <button type="button" data-wishlist-remove="${escapeHtml(item.id)}" aria-label="${escapeHtml(wishlistPageLabel('labelRemove', 'Remove'))} ${escapeHtml(item.title)}">
              ${removeIcon}
            </button>
          </div>
          <p class="buskins-wishlist-card__price">${escapeHtml(item.price || '')}</p>
          <div class="buskins-wishlist-card__actions">
            ${primaryAction}
            <a class="buskins-wishlist-card__view" href="${escapeHtml(item.url)}" aria-label="${escapeHtml(wishlistPageLabel('labelOptions', 'View item'))}">
              <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>
      </article>`;
  };

  const renderWishlistPage = (items = getWishlist()) => {
    if (!wishlistPage || !wishlistPageGrid || !wishlistPageEmpty || !wishlistPageToolbar) return;

    const count = items.length;
    const countElement = wishlistPage.querySelector('[data-wishlist-page-count]');
    const countLabel = wishlistPage.querySelector('[data-wishlist-page-count-label]');
    if (countElement) countElement.textContent = String(count);
    if (countLabel) {
      countLabel.textContent =
        count === 1
          ? wishlistPageLabel('labelOne', 'piece')
          : wishlistPageLabel('labelMany', 'pieces');
    }

    if (!count) {
      wishlistPageGrid.replaceChildren();
      wishlistPageGrid.hidden = true;
      wishlistPageToolbar.hidden = true;
      wishlistPageEmpty.hidden = false;
      return;
    }

    wishlistPageGrid.innerHTML = items.map(wishlistPageItemMarkup).join('');
    wishlistPageGrid.hidden = false;
    wishlistPageToolbar.hidden = false;
    wishlistPageEmpty.hidden = true;
  };

  const renderWishlist = () => {
    const items = getWishlist();
    updateHeaderCounts(Number(document.querySelector('[data-cart-count]')?.textContent || 0));
    renderWishlistPage(items);
    if (!items.length) {
      renderEmpty(wishlistBody, 'wishlist', false);
      wishlistFooter.hidden = true;
      return;
    }

    wishlistBody.innerHTML = `<div class="buskins-drawer__items">${items.map(wishlistItemMarkup).join('')}</div>`;
    wishlistFooter.hidden = false;
  };

  const toggleWishlist = (button) => {
    const item = {
      id: button.dataset.wishlistId,
      title: button.dataset.wishlistTitle,
      url: button.dataset.wishlistUrl,
      image: button.dataset.wishlistImage,
      price: button.dataset.wishlistPrice,
      variantId: button.dataset.wishlistVariantId,
      available: button.dataset.wishlistAvailable,
      addedAt: Date.now()
    };
    let items = getWishlist();
    const index = items.findIndex((saved) => saved.id === item.id);
    const adding = index < 0;

    if (adding) {
      items.unshift(item);
    } else {
      items.splice(index, 1);
    }

    saveWishlist(items);
    renderWishlist();
    announce(adding ? `${item.title} saved to your wishlist` : `${item.title} removed from your wishlist`);
  };

  const addVariant = async (variantId, quantity = 1) => {
    const response = await fetch(`${root.dataset.cartAddUrl}.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to add this piece');
    return result;
  };

  const quickViewLoading = () => {
    if (!quickViewBody) return;
    quickViewBody.innerHTML = `
      <div class="buskins-drawer__loading" aria-live="polite">
        <span></span>
        <p>Preparing this look…</p>
      </div>`;
  };

  const quickViewOptionMarkup = (option, index, selectedValue) => {
    const isColour = /colou?r/i.test(option.name);
    const visibleValues = option.values.filter((value) => value && value !== 'Default Title');
    if (!visibleValues.length) return '';

    return `
      <fieldset class="buskins-quick-view__option${isColour ? ' buskins-quick-view__option--colour' : ''}">
        <legend>${escapeHtml(option.name)}</legend>
        <div class="buskins-quick-view__option-values">
          ${visibleValues
            .map((value) => {
              const displayValue = typeof value === 'string' ? value : value.label;
              const swatch = typeof value === 'string' ? swatchForValue(value) : value.swatch;
              return `
                <button
                  type="button"
                  data-qv-option="${index}"
                  data-qv-value="${escapeHtml(displayValue)}"
                  aria-label="${isColour ? `Choose colour ${escapeHtml(displayValue)}` : `Choose ${escapeHtml(option.name)} ${escapeHtml(displayValue)}`}"
                  aria-pressed="${displayValue === selectedValue}"
                  ${isColour ? `style="--quick-swatch: ${escapeHtml(swatch)};" title="${escapeHtml(displayValue)}"` : ''}
                >${isColour ? '<span class="visually-hidden">' + escapeHtml(displayValue) + '</span>' : escapeHtml(displayValue)}</button>`;
            })
            .join('')}
        </div>
      </fieldset>`;
  };

  const renderQuickView = (product) => {
    if (!quickViewBody) return;
    quickViewState = product;
    const selected = product.selected.slice();
    const optionsMarkup = product.options
      .map((option, index) => quickViewOptionMarkup(option, index, selected[index]))
      .join('');
    const compareMarkup =
      product.comparePrice && product.comparePrice !== product.price
        ? `<s data-qv-compare>${escapeHtml(product.comparePrice)}</s>`
        : '<s data-qv-compare hidden></s>';

    quickViewBody.innerHTML = `
      <div class="buskins-quick-view__layout">
        <div class="buskins-quick-view__media">
          <img data-qv-image src="${escapeHtml(normalizeImageUrl(product.image))}" alt="${escapeHtml(product.title)}" width="800" height="1000">
          <span class="buskins-quick-view__badge">${product.available ? 'Ready to wear' : 'Sold out'}</span>
        </div>
        <div class="buskins-quick-view__information">
          <p class="buskins-quick-view__micro"><span>Buskins</span><span>Take the stage</span></p>
          <h3>${escapeHtml(product.title)}</h3>
          <p class="buskins-quick-view__price">
            <span data-qv-price>${escapeHtml(product.price)}</span>
            ${compareMarkup}
          </p>
          <p class="buskins-quick-view__description">${escapeHtml(product.description || 'Colour-forward modest style with an easy, confident fit for every plan.')}</p>
          ${optionsMarkup ? `<div class="buskins-quick-view__options">${optionsMarkup}</div>` : ''}
          <p class="buskins-quick-view__availability" data-qv-availability>${product.available ? 'In stock — ready to ship' : 'Currently unavailable'}</p>
          <div class="buskins-quick-view__actions">
            <button
              class="buskins-quick-view__add"
              type="button"
              ${product.demo ? 'data-qv-demo-add' : `data-qv-add="${escapeHtml(product.variantId || '')}"`}
              ${product.available ? '' : 'disabled'}
            >
              <span>${product.available ? 'Add to bag' : 'Sold out'}</span>
              <span data-qv-button-price>${escapeHtml(product.price)}</span>
            </button>
            <a class="buskins-quick-view__details" href="${escapeHtml(product.url)}">View full product details →</a>
          </div>
        </div>
      </div>`;
  };

  const buildDemoQuickView = (trigger) => {
    const sizes = (trigger.dataset.qvSizes || 'S,M,L').split(',').filter(Boolean);
    const swatches = (trigger.dataset.qvSwatches || '#B7C9DA,#E9CEC3,#EFE3D6').split(',').filter(Boolean);
    return {
      demo: true,
      title: trigger.dataset.qvTitle || 'Buskins look',
      url: trigger.dataset.qvUrl || root.dataset.shopUrl,
      image: trigger.dataset.qvImage || '',
      price: trigger.dataset.qvPrice || 'EGP 1,890',
      comparePrice: trigger.dataset.qvComparePrice || '',
      description: 'An expressive Buskins piece designed for easy styling, confident colour and comfortable modest coverage.',
      available: trigger.dataset.qvAvailable !== 'false',
      variantId: '',
      options: [
        {
          name: 'Colour',
          values: swatches.map((swatch, index) => ({
            label: ['Featured colour', 'Blush mix', 'Soft neutral'][index] || `Colour ${index + 1}`,
            swatch
          }))
        },
        { name: 'Size', values: sizes }
      ],
      selected: ['Featured colour', sizes[0] || 'M']
    };
  };

  const buildShopifyQuickView = (data, trigger) => {
    const variants = data.variants || [];
    const selectedVariant = variants.find((variant) => variant.available) || variants[0] || {};
    const optionNames = (data.options || []).map((option, index) =>
      typeof option === 'string' ? option : option.name || `Option ${index + 1}`
    );
    const options = optionNames.map((name, index) => ({
      name,
      values: [...new Set(variants.map((variant) => variant.options?.[index]).filter(Boolean))]
    }));
    const image =
      selectedVariant.featured_image?.src ||
      selectedVariant.featured_image ||
      data.featured_image ||
      data.images?.[0] ||
      trigger.dataset.qvImage ||
      '';

    return {
      demo: false,
      title: data.title || trigger.dataset.qvTitle,
      url: trigger.dataset.qvUrl || data.url || root.dataset.shopUrl,
      image,
      price: money(selectedVariant.price ?? data.price),
      comparePrice:
        selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price
          ? money(selectedVariant.compare_at_price)
          : '',
      description: stripHtml(data.description).slice(0, 260),
      available: Boolean(selectedVariant.available),
      variantId: String(selectedVariant.id || ''),
      options,
      selected: selectedVariant.options || [],
      variants
    };
  };

  const openQuickView = async (trigger) => {
    await openDrawer('quick-view', trigger);
    quickViewLoading();

    if (trigger.dataset.qvDemo === 'true') {
      renderQuickView(buildDemoQuickView(trigger));
      return;
    }

    try {
      const productUrl = (trigger.dataset.qvUrl || '').split('?')[0];
      const response = await fetch(`${productUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load this product');
      renderQuickView(buildShopifyQuickView(await response.json(), trigger));
    } catch (error) {
      quickViewBody.innerHTML = `
        <div class="buskins-drawer__empty">
          <span class="buskins-drawer__empty-index">Quick view</span>
          <h3>Let’s open the full look.</h3>
          <p>${escapeHtml(error.message)}</p>
          <a class="buskins-drawer__primary-link" href="${escapeHtml(trigger.dataset.qvUrl || root.dataset.shopUrl)}">
            <span>View product</span><span aria-hidden="true">→</span>
          </a>
        </div>`;
    }
  };

  const updateQuickViewVariant = () => {
    if (!quickViewState || quickViewState.demo) return;
    const selected = quickViewState.selected;
    const variant = quickViewState.variants.find((item) =>
      item.options.every((value, index) => value === selected[index])
    );
    if (!variant) return;

    quickViewState.variantId = String(variant.id);
    quickViewState.available = Boolean(variant.available);
    quickViewState.price = money(variant.price);
    quickViewState.comparePrice =
      variant.compare_at_price && variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';

    const price = quickViewBody.querySelector('[data-qv-price]');
    const compare = quickViewBody.querySelector('[data-qv-compare]');
    const add = quickViewBody.querySelector('[data-qv-add]');
    const availability = quickViewBody.querySelector('[data-qv-availability]');
    const image = quickViewBody.querySelector('[data-qv-image]');
    if (price) price.textContent = quickViewState.price;
    if (compare) {
      compare.textContent = quickViewState.comparePrice;
      compare.hidden = !quickViewState.comparePrice;
    }
    if (add) {
      add.dataset.qvAdd = quickViewState.variantId;
      add.disabled = !quickViewState.available;
      add.querySelector('span')?.replaceChildren(document.createTextNode(quickViewState.available ? 'Add to bag' : 'Sold out'));
      const buttonPrice = add.querySelector('[data-qv-button-price]');
      if (buttonPrice) buttonPrice.textContent = quickViewState.price;
    }
    if (availability) {
      availability.textContent = quickViewState.available ? 'In stock — ready to ship' : 'This option is currently unavailable';
    }
    const variantImage = variant.featured_image?.src || variant.featured_image;
    if (image && variantImage) image.src = normalizeImageUrl(variantImage);
  };

  document.addEventListener('click', async (event) => {
    const checkoutLink = event.target.closest('[data-cart-checkout]');
    if (checkoutLink && getDemoCart()) {
      event.preventDefault();
      closeDrawer();
      window.location.assign(root.dataset.cartUrl);
      return;
    }

    const quickViewTrigger = event.target.closest('[data-quick-view-item]');
    if (quickViewTrigger) {
      event.preventDefault();
      await openQuickView(quickViewTrigger);
      return;
    }

    const openTrigger = event.target.closest('[data-drawer-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer(openTrigger.dataset.drawerOpen, openTrigger);
      return;
    }

    if (event.target.closest('[data-drawer-close]')) {
      closeDrawer();
      return;
    }

    const quickOption = event.target.closest('[data-qv-option]');
    if (quickOption && quickViewState) {
      const index = Number(quickOption.dataset.qvOption);
      quickViewState.selected[index] = quickOption.dataset.qvValue;
      quickOption.closest('.buskins-quick-view__option-values')?.querySelectorAll('[data-qv-option]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === quickOption));
      });
      updateQuickViewVariant();
      return;
    }

    const quickAdd = event.target.closest('[data-qv-add]');
    if (quickAdd) {
      quickAdd.disabled = true;
      try {
        await addVariant(quickAdd.dataset.qvAdd);
        announce(`${quickViewState?.title || 'Item'} added to your bag`);
        await openDrawer('cart', document.querySelector('[data-drawer-open="cart"]'));
      } catch (error) {
        announce(error.message);
        quickAdd.disabled = false;
      }
      return;
    }

    const demoQuickAdd = event.target.closest('[data-qv-demo-add]');
    if (demoQuickAdd && quickViewState) {
      const item = {
        id: `quick-${quickViewState.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
        title: quickViewState.title,
        product_title: quickViewState.title,
        url: quickViewState.url,
        image: quickViewState.image,
        price: priceTextToCents(quickViewState.price),
        quantity: 1,
        optionsText: quickViewState.selected.filter(Boolean).join(' / ')
      };
      saveDemoCart(item);
      announce(`${quickViewState.title} added to your preview bag`);
      await openDrawer('cart', document.querySelector('[data-drawer-open="cart"]'));
      return;
    }

    const wishlistButton = event.target.closest('[data-wishlist-item]');
    if (wishlistButton) {
      event.preventDefault();
      toggleWishlist(wishlistButton);
      return;
    }

    const removeWishlist = event.target.closest('[data-wishlist-remove]');
    if (removeWishlist) {
      const items = getWishlist().filter((item) => item.id !== removeWishlist.dataset.wishlistRemove);
      saveWishlist(items);
      renderWishlist();
      announce('Item removed from your wishlist');
      return;
    }

    if (event.target.closest('[data-wishlist-clear]')) {
      saveWishlist([]);
      renderWishlist();
      announce('Wishlist cleared');
      return;
    }

    const wishlistAdd = event.target.closest('[data-wishlist-add]');
    if (wishlistAdd) {
      wishlistAdd.disabled = true;
      try {
        await addVariant(wishlistAdd.dataset.wishlistAdd);
        const items = getWishlist().filter((item) => item.id !== wishlistAdd.dataset.wishlistId);
        saveWishlist(items);
        renderWishlist();
        announce('Added to your bag');
        await openDrawer('cart', wishlistAdd);
      } catch (error) {
        announce(error.message);
      } finally {
        wishlistAdd.disabled = false;
      }
      return;
    }

    const cartLine = event.target.closest('[data-cart-line]');
    if (cartLine) {
      const quantity = Number(cartLine.querySelector('.buskins-drawer-item__quantity span')?.textContent || 1);
      if (event.target.closest('[data-cart-remove]')) {
        changeCartItem(cartLine.dataset.cartLine, 0);
      } else if (event.target.closest('[data-cart-quantity-minus]')) {
        changeCartItem(cartLine.dataset.cartLine, Math.max(0, quantity - 1));
      } else if (event.target.closest('[data-cart-quantity-plus]')) {
        changeCartItem(cartLine.dataset.cartLine, quantity + 1);
      }
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      const demoAdd = event.target.closest('[data-demo-add]');
      if (!demoAdd) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const section = demoAdd.closest('[data-product-section]');
      const quantity = Number(section?.querySelector('[data-quantity] input')?.value || 1);
      const item = getDemoCart() || {
        id: 'buskins-demo-stage-print',
        title: 'The Stage Print Co-ord',
        product_title: 'The Stage Print Co-ord',
        url: section?.dataset.productUrl || root.dataset.shopUrl,
        image: document.querySelector('[data-product-gallery] img')?.src || '',
        price: 189000,
        quantity: 0
      };
      item.quantity += quantity;
      saveDemoCart(item);
      announce('The Stage Print Co-ord added to your preview bag');
      openDrawer('cart', demoAdd);
    },
    true
  );

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.noAjax === 'true') return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    submit?.setAttribute('aria-busy', 'true');
    if (submit) submit.disabled = true;

    try {
      const response = await fetch(`${root.dataset.cartAddUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this piece');
      announce(`${result.product_title || 'Item'} added to your bag`);
      await openDrawer('cart', submit);
    } catch (error) {
      announce(error.message);
    } finally {
      submit?.removeAttribute('aria-busy');
      if (submit) submit.disabled = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!activeDrawer) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = getFocusable(activeDrawer);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('storage', (event) => {
    if (event.key === wishlistKey) renderWishlist();
  });

  updateHeaderCounts(Number(document.querySelector('[data-cart-count]')?.textContent || 0));
  renderWishlist();
  document.addEventListener('shopify:section:load', () => {
    updateHeaderCounts(Number(document.querySelector('[data-cart-count]')?.textContent || 0));
  });
})();
